// dont use any rtkQuery hook in this component as this renders on api error
// as well. In case the api breaks and you call the hook here, it will cause infinite loop.

import { useGetAddonsDataQuery } from '@/src/api/rtkQuery/addonsApi'
import useSmbMandatoryCheck from '@/src/hooks/itinerary/addons/useSmbMandatoryCheck'
import useGetItineraryId from '@/src/hooks/itinerary/useGetItineraryId'
import useRedirectToPage from '@/src/hooks/navigation/useRedirectToPage'
import { useTranslations } from 'next-intl'
import ErrorModal from './addonsUpdateFailureModal'

const AddonsUpdateFailureModal = ({
    setShowAddonsErrorModal,
    onContinue
}: {
    setShowAddonsErrorModal: (show: boolean) => void
    onContinue: () => void
}) => {
    const t = useTranslations('errorModal')
    const redirectToPage = useRedirectToPage()
    const { isSeatMandatory, isMealMandatory } = useSmbMandatoryCheck()
    const itineraryId = useGetItineraryId()
    const { refetch } = useGetAddonsDataQuery({ itineraryId })

    const primaryError = t('couldntSaveYourAddonsPrimaryMessage')
    const secondaryError = t('couldntSaveYourAddonsSecondaryMessage')
    const primaryButtonText = t('reloadAddons')
    const secondaryButtonText = isSeatMandatory || isMealMandatory ? '' : t('continueToTravellers')

    const primaryButtonAction = () => {
        refetch()
        setShowAddonsErrorModal(false)
    }
    const secondaryButtonAction = () => {
        onContinue()
        setShowAddonsErrorModal(false)
    }

    return (
        <ErrorModal
            isOpen={true}
            primaryError={primaryError}
            secondaryError={secondaryError}
            primaryButtonText={primaryButtonText}
            primaryButtonAction={primaryButtonAction}
            secondaryButtonText={secondaryButtonText}
            secondaryButtonAction={secondaryButtonAction}
        />
    )
}

export default AddonsUpdateFailureModal
